<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
      @close="beforeClose"
      @submit="confirm"
    class="pushMsgDialog"
  >
    <qrcode-form
      ref="outform"
      @submit="submitHandle"
    ></qrcode-form>
  </sliderBarDialogShell>
</template>

<script>

import qrcodeForm from "./qrcodeForm";
import {addParamsQrcode} from "../../../api/wx/wx-qrcode";

export default {
  name: "addQrCodeDialog",
  components: {
    qrcodeForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增带参数二维码'
    }
  },
  methods: {
    openDialog(){
      this.$emit('open-dialog');
    },
    beforeClose() {
      this.$emit('close');
      this.$refs.outform && this.$refs.outform.selfClear();
    },
    submitHandle(form){
      addParamsQrcode(form).then((res) => {
        if(res.code == 200){
          this.$message.success('添加成功')
          this.$emit('add-success');
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    editSuccess(){
      this.$emit('send-success');
    },
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .pushMsgDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
